export const DEPARTMENTS = "departments";
export const DEPARTMENT_ADD = "department_add";
export const DEPARTMENT_EDIT = "department_edit";
export const DEPARTMENT_DELETE = "department_deleted";

export const DEPARTMENT_SETROWDATA = "department_eet_rowdata";
export const MODEL_OPEN = "department_model_open";
export const MODEL_CLOSE = "department_model_close";

export const DEPARTMENT_LIST_SUCCESSFUL = "department_list_successfull";
export const DEPARTMENT_ADD_SUCCESSFUL = "department_add_successfull";
export const DEPARTMENT_EDIT_SUCCESSFUL = "department_edit_successfull";

export const API_ERROR = "api_failed";
